//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class PluginData extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'PluginData';
  }

  urlRoot() {
    // @ts-ignore
    return `/1/${this.get('scope')}/${this.get('idModel')}/pluginData`;
  }
}
PluginData.initClass();

export { PluginData };
